

































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import type { EstacaoDeImpressaoServiceAdapter } from '@/usecases'
import {
	criarEstacaoDeImpressao,
	EstacaoDeImpressao,
	LinguagemDeImpressora,
	linguagensDeImpressora,
} from '@/models/EstacaoDeImpressao'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DialogoDeEdicaoDeEstacaoDeImpressao from './DialogoDeEdicaoDeEstacaoDeImpressao.vue'
import ConfirmExclusionDialog from '@/components/ui/ConfirmExclusionDialog.vue'

@Component({
	components: {
		DialogoDeEdicaoDeEstacaoDeImpressao,
		ConfirmExclusionDialog,
	},
})
export default class ListaDeEstacoesDeImpressao extends Vue {
	@Prop({ type: String, default: '' }) lojaId!: string
	@Ref() dialogo!: DialogoDeEdicaoDeEstacaoDeImpressao

	@Inject('EstacaoDeImpressaoServiceAdapter')
	private estacaoDeImpressaoService!: EstacaoDeImpressaoServiceAdapter

	estacoes: EstacaoDeImpressao[] = []
	carregando = false
	excluindoId: string | null = null

	headers = [
		{ text: 'Nome', value: 'nome' },
		{ text: 'Identificador', value: 'identificador' },
		{ text: 'Impressora', value: 'identificadorDaImpressora' },
		{ text: 'Conexão', value: 'tipoDeConexao' },
		{ text: 'Situação', value: 'ativo' },
		{ text: 'Ações', value: 'acoes', sortable: false, align: 'center', width: 120 },
	]

	@Watch('lojaId', { immediate: true })
	onChangeLojaId() {
		if (!this.lojaId) {
			this.estacoes = []
			return
		}
		this.carregar()
	}

	async carregar() {
		try {
			this.carregando = true
			this.estacoes = await this.estacaoDeImpressaoService.findEstacoesDeImpressaoPorLoja(this.lojaId)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	linguagemImprime(linguagem: LinguagemDeImpressora) {
		return linguagensDeImpressora.find(item => item.valor === linguagem)?.imprime ?? false
	}

	criar() {
		this.dialogo.mostrar(criarEstacaoDeImpressao(this.lojaId))
	}

	editar(estacao: EstacaoDeImpressao) {
		this.dialogo.mostrar(estacao)
	}

	async excluir(estacao: EstacaoDeImpressao) {
		try {
			this.excluindoId = estacao.id
			await this.estacaoDeImpressaoService.deleteEstacaoDeImpressao(estacao.id)
			AlertModule.setSuccess(`Estação "${estacao.nome}" excluída`)
			await this.carregar()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.excluindoId = null
		}
	}

	aoSalvar() {
		this.carregar()
	}
}
